export default function GS_Undo_Redo() {
  return (
    <div className="p-4">
      <h1>GS Undo Redo</h1>
    </div>
  );
}
